import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Calendar } from './pages/Calendar';
import { Services } from './pages/Services';
import { Barbers } from './pages/Barbers';
import { Locations } from './pages/Locations';
import { Rosters } from './pages/Rosters';
import { Reports } from './pages/Reports';
import { Terminals } from './pages/Terminals';
import { Expenses } from './pages/Expenses';
import { Inventory } from './pages/Inventory';
import { Messaging } from './pages/Messaging';
import { Holidays } from './pages/Holidays';
import { SupplyRequests } from './pages/SupplyRequests';
import { AdTracking } from './pages/AdTracking';
import { PayrollSettings } from './pages/PayrollSettings';
import { PayrollTimesheets } from './pages/PayrollTimesheets';
import { PayrollPayRuns } from './pages/PayrollPayRuns';
import { PayrollPayRunDetail } from './pages/PayrollPayRunDetail';
import { PayrollLeave } from './pages/PayrollLeave';
import { PayrollRun } from './pages/PayrollRun';
import { HealthCheck } from './pages/HealthCheck';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();

  if (user?.role !== 'ADMIN') {
    return <Navigate to="/calendar" replace />;
  }

  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/calendar" replace />} />
        <Route path="calendar" element={<Calendar />} />
        <Route
          path="services"
          element={
            <AdminRoute>
              <Services />
            </AdminRoute>
          }
        />
        <Route
          path="barbers"
          element={
            <AdminRoute>
              <Barbers />
            </AdminRoute>
          }
        />
        <Route
          path="locations"
          element={
            <AdminRoute>
              <Locations />
            </AdminRoute>
          }
        />
        <Route
          path="rosters"
          element={
            <AdminRoute>
              <Rosters />
            </AdminRoute>
          }
        />
        <Route path="reports" element={<Reports />} />
        <Route
          path="health-check"
          element={
            <AdminRoute>
              <HealthCheck />
            </AdminRoute>
          }
        />
        <Route path="terminals" element={<Terminals />} />
        <Route
          path="expenses"
          element={
            <AdminRoute>
              <Expenses />
            </AdminRoute>
          }
        />
        <Route
          path="inventory"
          element={
            <AdminRoute>
              <Inventory />
            </AdminRoute>
          }
        />
        <Route
          path="messaging"
          element={
            <AdminRoute>
              <Messaging />
            </AdminRoute>
          }
        />
        <Route
          path="holidays"
          element={
            <AdminRoute>
              <Holidays />
            </AdminRoute>
          }
        />
        <Route
          path="ad-tracking"
          element={
            <AdminRoute>
              <AdTracking />
            </AdminRoute>
          }
        />
        <Route path="supply-requests" element={<SupplyRequests />} />
        <Route
          path="payroll/settings"
          element={
            <AdminRoute>
              <PayrollSettings />
            </AdminRoute>
          }
        />
        <Route
          path="payroll/timesheets"
          element={
            <AdminRoute>
              <PayrollTimesheets />
            </AdminRoute>
          }
        />
        <Route
          path="payroll/pay-runs"
          element={
            <AdminRoute>
              <PayrollPayRuns />
            </AdminRoute>
          }
        />
        <Route
          path="payroll/pay-runs/:id"
          element={
            <AdminRoute>
              <PayrollPayRunDetail />
            </AdminRoute>
          }
        />
        <Route
          path="payroll/leave"
          element={
            <AdminRoute>
              <PayrollLeave />
            </AdminRoute>
          }
        />
        <Route
          path="payroll/run"
          element={
            <AdminRoute>
              <PayrollRun />
            </AdminRoute>
          }
        />
      </Route>
    </Routes>
  );
}
